import {GlobalVariable} from "@gongt/ts-stl-library/pattern/global-page-data";

const globalVar = new GlobalVariable(global);
